export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm text-foreground-600">有影视资源推荐或问题反馈？欢迎联系我们</p>
          </div>

          <div className="bg-background-100 border border-background-200 rounded-xl p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="space-y-1">
                <span className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-primary-500"></i>
                </span>
                <div className="text-sm font-medium text-foreground-900">投稿邮箱</div>
                <div className="text-xs text-foreground-500">submit@51yingyuan.com</div>
              </div>
              <div className="space-y-1">
                <span className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-wechat-line text-accent-500"></i>
                </span>
                <div className="text-sm font-medium text-foreground-900">微信公众号</div>
                <div className="text-xs text-foreground-500">51影院官方</div>
              </div>
              <div className="space-y-1">
                <span className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-question-line text-secondary-500"></i>
                </span>
                <div className="text-sm font-medium text-foreground-900">反馈建议</div>
                <div className="text-xs text-foreground-500">feedback@51yingyuan.com</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}